(function() {
  'use strict';

  var PRODUCT_SECTION_SELECTOR = '.product-section';
  var DATA_ISLAND_SELECTOR = 'script[data-quick-add-variants]';

  class HideSoldVariants {
    constructor() {
      this.debounceTimers = new WeakMap();

      this.applyInitialStyling();
      this.init();
    }

    applyInitialStyling() {
      const style = document.createElement('style');
      style.textContent = `
        [data-value].disabled::after,
        .paint-option__item.disabled::after,
        .selector-wrapper .disabled::after {
          display: none !important;
        }

        [data-value].disabled,
        .paint-option__item.disabled {
          opacity: 0.85 !important;
          filter: grayscale(60%) !important;
          text-decoration: none !important;
        }
      `;
      document.head.appendChild(style);
    }

    init() {
      console.log('HideSoldVariants: Initializing...');

      this.processAllContainers();
      this.setupEventListeners();

      [100, 300, 600, 1000].forEach(delay => {
        setTimeout(() => this.debouncedProcessAll(), delay);
      });

      this.initialized = true;
      console.log('HideSoldVariants: Initialized');
    }

    loadVariantData(container) {
      const island = container.querySelector(DATA_ISLAND_SELECTOR);
      if (island && island.textContent.trim()) {
        try {
          const parsed = JSON.parse(island.textContent);
          if (Array.isArray(parsed)) {
            return parsed;
          }
        } catch (e) {
          console.warn('HideSoldVariants: could not parse variant data island', e);
        }
      }

      if (window.productVariantsData) {
        return window.productVariantsData;
      }

      if (window.product && window.product.variants) {
        return window.product.variants.map(v => ({
          ...v,
          option1: v.option1,
          option2: v.option2,
          option3: v.option3,
          available: v.available,
          exclude_from_hide: (v.metafields && v.metafields.exclude_from_hide) || false
        }));
      }

      return [];
    }

    getCurrentSelections(container) {
      const selections = {};
      for (let i = 1; i <= 3; i++) {
        const selected = container.querySelector(`[data-index="option${i}"] input[type="radio"]:checked`);
        if (selected) {
          selections[`option${i}`] = selected.value;
        }
      }
      return selections;
    }

    getMatchingVariants(variants, optionNum, optionValue, selections) {
      const testSelections = { ...selections };
      testSelections[`option${optionNum}`] = optionValue;

      return variants.filter(variant => {
        for (let i = 1; i <= optionNum; i++) {
          const variantValue = variant[`option${i}`];
          const selectedValue = testSelections[`option${i}`];

          if (selectedValue && variantValue !== selectedValue) {
            return false;
          }
        }
        return true;
      });
    }

    shouldHideOption(variants, optionNum, optionValue, selections) {
      const matchingVariants = this.getMatchingVariants(variants, optionNum, optionValue, selections);

      if (matchingVariants.length === 0) {
        return true;
      }

      const allSoldOut = matchingVariants.every(v => !v.available);

      const anyExcluded = matchingVariants.some(v => v.exclude_from_hide);
      const allowExclusions = window.theme?.settings?.allow_excluded_variants !== false;

      if (anyExcluded && allowExclusions) {
        return false;
      }

      return allSoldOut;
    }

    processAllContainers() {
      const containers = document.querySelectorAll(PRODUCT_SECTION_SELECTOR);
      containers.forEach(container => this.processContainer(container));
    }

    processContainer(container) {
      const variants = this.loadVariantData(container);

      if (!variants || variants.length === 0) {
        return;
      }

      const selections = this.getCurrentSelections(container);

      for (let optionNum = 1; optionNum <= 3; optionNum++) {
        this.processOption(container, variants, optionNum, selections);
      }
    }

    processOption(container, variants, optionNum, selections) {
      const optionKey = `option${optionNum}`;
      const wrapper = container.querySelector(`[data-index="${optionKey}"]`);

      if (!wrapper) return;

      const options = wrapper.querySelectorAll('[data-value]');
      let hiddenCount = 0;

      options.forEach(option => {
        const value = option.dataset.value;
        const shouldHide = this.shouldHideOption(variants, optionNum, value, selections);

        const matchingVariants = this.getMatchingVariants(variants, optionNum, value, selections);
        const allSoldOut = matchingVariants.length > 0 && matchingVariants.every(v => !v.available);
        const anyExcluded = matchingVariants.some(v => v.exclude_from_hide);
        const allowExclusions = window.theme?.settings?.allow_excluded_variants !== false;

        if (shouldHide) {
          if (option.style.display !== 'none') {
            option.style.display = 'none';
            option.style.visibility = 'hidden';
            option.dataset.hiddenBySoldout = 'true';
            hiddenCount++;
          }

          option.classList.remove('excluded-sold-out');
          option.removeAttribute('data-excluded-sold-out');
        } else {
          if (option.style.display === 'none') {
            option.style.display = '';
            option.style.visibility = '';
            delete option.dataset.hiddenBySoldout;
          }

          if (allSoldOut && anyExcluded && allowExclusions) {
            option.setAttribute('data-excluded-sold-out', 'true');
            option.classList.add('excluded-sold-out');
          } else {
            option.classList.remove('excluded-sold-out');
            option.removeAttribute('data-excluded-sold-out');
          }
        }
      });

      if (hiddenCount > 0) {
        console.log(`HideSoldVariants: hidden ${hiddenCount} options for ${optionKey}`);
      }
    }

    debouncedProcess(container) {
      const existing = this.debounceTimers.get(container);
      if (existing) {
        clearTimeout(existing);
      }
      const timer = setTimeout(() => {
        this.processContainer(container);
      }, 50);
      this.debounceTimers.set(container, timer);
    }

    debouncedProcessAll() {
      document.querySelectorAll(PRODUCT_SECTION_SELECTOR).forEach(container => {
        this.debouncedProcess(container);
      });
    }

    setupEventListeners() {
      document.addEventListener('change', (e) => {
        if (e.target.matches('[data-index^="option"] input[type="radio"]')) {
          const container = e.target.closest(PRODUCT_SECTION_SELECTOR) || document;
          if (container === document) {
            this.debouncedProcessAll();
          } else {
            this.debouncedProcess(container);
          }
        }
      });

      document.addEventListener('variantChange', () => {
        this.debouncedProcessAll();
      });

      document.addEventListener('quickadd:loaded', () => {
        this.debouncedProcessAll();
      });

      const observer = new MutationObserver(() => {
        this.debouncedProcessAll();
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }
  }

  window.HideSoldVariants = new HideSoldVariants();
})();
